(function() {
  var cookieMatch = document.cookie.match(/(?:^|;\s*)vip_access=([^;]*)/);
  var hasAccess = !!cookieMatch;
  var VIP_SELECTOR = '[data-vip-product], [data-vip-nav]';

  function revealVipItems(root) {
    if (root.matches && root.matches(VIP_SELECTOR)) root.style.display = '';
    if (root.querySelectorAll) root.querySelectorAll(VIP_SELECTOR).forEach(function(el) { el.style.display = ''; });
  }

  function findCountEl(root) {
    if (root.id === 'ProductCount' || root.id === 'ProductCountDesktop') return root;
    if (root.querySelector) return root.querySelector('#ProductCount, #ProductCountDesktop');
    return null;
  }

  function adjustCount(countEl, amount) {
    if (!countEl || !amount) return;
    countEl.textContent = countEl.textContent.replace(/\d+/, function(n) {
      return Math.max(0, parseInt(n, 10) - amount);
    });
  }

  function removeVipItems(root) {
    var removedCount = 0;
    if (root.matches && root.matches(VIP_SELECTOR)) {
      if (root.hasAttribute('data-vip-product')) removedCount++;
      if (root.parentNode) root.parentNode.removeChild(root);
      return removedCount;
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-vip-product]').forEach(function(el) {
        removedCount++;
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      root.querySelectorAll('[data-vip-nav]').forEach(function(el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    }
    return removedCount;
  }

  if (hasAccess) {
    revealVipItems(document);
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) revealVipItems(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  } else {
    var removed = removeVipItems(document);
    adjustCount(findCountEl(document), removed);
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          var removedFromNode = removeVipItems(node);
          var countEl = findCountEl(node) || (removedFromNode > 0 ? findCountEl(document) : null);
          adjustCount(countEl, removedFromNode);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
